import { render, staticRenderFns } from "./CauseOfMaintanceForm.vue?vue&type=template&id=d0a70aa0"
import script from "./CauseOfMaintanceForm.vue?vue&type=script&lang=js"
export * from "./CauseOfMaintanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports